<script lang="ts">
	import type { Boat } from '../api';
	import Card from './Card.svelte';
	import CardActions from './CardActions.svelte';

	let {
		boat,
		onEdit,
		onDelete,
		onView,
		showActions = true
	}: {
		boat: Boat;
		onEdit?: (boat: Boat) => void;
		onDelete?: (boat: Boat) => void;
		onView?: (boat: Boat) => void;
		showActions?: boolean;
	} = $props();

	function handleEdit() {
		if (onEdit) {
			onEdit(boat);
		}
	}

	function handleDelete() {
		if (onDelete) {
			onDelete(boat);
		}
	}

	function handleView() {
		if (onView) {
			onView(boat);
		}
	}
</script>

<Card>
	<div class="flex items-start justify-between">
		<div class="min-w-0 flex-1">
			<h3 class="truncate text-lg font-medium text-gray-900">{boat.name}</h3>
			<p class="mt-1 text-sm text-gray-500">{boat.model || 'Unknown Model'}</p>

			<div class="mt-2 space-y-1 text-sm text-gray-600">
				{#if boat.brand}
					<div class="flex items-center">
						<span class="font-medium">Brand:</span>
						<span class="ml-1">{boat.brand}</span>
					</div>
				{/if}
				{#if boat.model}
					<div class="flex items-center">
						<span class="font-medium">Model:</span>
						<span class="ml-1">{boat.model}</span>
					</div>
				{/if}
				{#if boat.sailNumber}
					<div class="flex items-center">
						<span class="font-medium">Sail Number:</span>
						<span class="ml-1">{boat.sailNumber}</span>
					</div>
				{/if}
				{#if boat.owners && boat.owners.length > 0}
					<div class="flex items-start">
						<span class="font-medium">Owner(s):</span>
						<div class="ml-1 flex flex-wrap gap-1">
							{#each boat.owners as owner (owner.id)}
								<button
									onclick={() => (window.location.href = `/users/${owner.id}`)}
									class="text-blue-600 hover:text-blue-800 hover:underline"
								>
									{owner.firstName}
									{owner.lastName}
								</button>
								{#if boat.owners.indexOf(owner) < boat.owners.length - 1}
									<span class="text-gray-400">,</span>
								{/if}
							{/each}
						</div>
					</div>
				{/if}
			</div>
		</div>

		{#if showActions}
			<div class="ml-4">
				<CardActions
					onView={onView ? handleView : undefined}
					onEdit={onEdit ? handleEdit : undefined}
					onDelete={onDelete ? handleDelete : undefined}
					viewTitle="View boat details"
					editTitle="Edit boat"
					deleteTitle="Delete boat"
				/>
			</div>
		{/if}
	</div>
</Card>
